import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'dark',
};

const selectedTheme = createSlice({
  name: 'selectedTheme',
  initialState,
  reducers: {
    setSelectedTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setSelectedTheme } = selectedTheme.actions;

export default selectedTheme.reducer;